var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// x-toggle-button.ts
import "@adornis/base/utilTypes.js";
import { RXController } from "@adornis/chemistry/controllers/RXController.js";
import "@adornis/chemistry/elements/components/x-flex.js";
import "@adornis/chemistry/elements/components/x-icon.js";
import { DesignSystem } from "@adornis/chemistry/elements/theming/design.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import { FormField } from "@adornis/formfield/form-field.js";
import { html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
var XToggleButton = class extends FormField {
  constructor() {
    super(...arguments);
    this.styles = () => [
      {
        ":host": { cursor: "pointer", userSelect: "none" },
        "div[togglewrapper]": {
          boxSizing: "border-box",
          display: "block",
          padding: "1px",
          borderRadius: `calc(${this.spacing.md} / 2 + 1px)`,
          background: this.colors.neutral.shade(100),
          width: `calc(2 * ${this.spacing.md} + 2px)`
        },
        "[toggle]": {
          background: this.colors.black,
          height: this.spacing.md,
          width: this.spacing.md,
          borderRadius: `calc(${this.spacing.md} / 2)`,
          transition: "transform .12s, backgroundColor .12s",
          "&[toggled]": {
            background: this.colors.accent,
            transform: "translateX(100%)",
            [`${DesignSystem.prefix}-icon`]: {
              color: this.colors.on.accent
            }
          },
          [`${DesignSystem.prefix}-icon`]: {
            color: this.colors.on.black,
            fontSize: this.baseFontSize
          }
        },
        ":host([disabled])": { "[toggle]": { opacity: ".5" } }
      }
    ];
    this.value = new RXController(this, false);
    this.label = "";
    this.reverse = false;
  }
  render() {
    return xComponents(html`
      <x-flex
        tabindex="0"
        horizontal
        crossaxis-center
        space="sm"
        ?reverse=${this.reverse}
        @keyup=${(e) => {
      if (e.key === "Enter")
        this._toggle();
    }}
        @click=${() => this._toggle()}
      >
        <div togglewrapper flex-none>
          <x-flex toggle center crossaxis-center ?toggled=${this.value.value}>
            ${this.disabled ? html`<x-icon> close </x-icon>` : nothing}
          </x-flex>
        </div>
        ${this.label ? html`<x-text> ${this.label} </x-text>` : nothing}
      </x-flex>
    `);
  }
  _toggle() {
    if (!this.disabled) {
      this.value.next(!this.value.value);
      this.dispatchEvent(new CustomEvent("value-picked", { detail: { value: this.value.value } }));
    }
  }
};
__decorateClass([
  property()
], XToggleButton.prototype, "label", 2);
__decorateClass([
  property({ type: Boolean })
], XToggleButton.prototype, "reverse", 2);
XToggleButton = __decorateClass([
  customElement("x-toggle-button")
], XToggleButton);
export {
  XToggleButton
};
